<template>
  <div>
      <JsonSchemaTreeNode v-model="items" @input="onTreeChange">
      </JsonSchemaTreeNode>
      <div class="d-flex mt-3">
        <b-button class="ml-auto" variant="primary" size="sm" @click.prevent="add">
          <i class="fa fa-plus"/> {{ $dt('json_schema.add_item', 'Add Item') }}
        </b-button>
    </div>
  </div>
</template>

<script>
import merge from 'lodash.merge';
import { v4 as uuidv4 } from 'uuid';
import JsonSchemaTreeNode from './JsonSchemaTreeNode.vue';

export default {
  name: 'JsonSchemaTree',
  components: {
    JsonSchemaTreeNode,
  },
  props: {
    schema: {
      type: Object,
      required: true,
    },
    tree: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      items: [],
    };
  },
  mounted() {
    this.items = this.prepareItems(this.tree);
  },
  methods: {
    add() {
      this.items.push({
        children_recursive: [],
        display_in_list: 0,
        filter_null: 0,
        in_filter: 0,
        is_set: 0,
        lookup_key: '',
        name: 'New Item',
        order: this.items.length,
        parent_id: null,
        parse_options: null,
        schema_id: this.schema.id,
        type: 0,
        uuid: uuidv4(),
        formVisible: true,
      });

      this.$emit('input', this.collectFlatTree(this.items));
    },
    prepareItems(items) {
      return merge([], items).map((item) => {
        item.formVisible = false;
        item.children_recursive = this.prepareItems(item.children_recursive);
        return item;
      });
    },
    onTreeChange(value) {
      this.$emit('input', this.collectFlatTree(value));
    },
    collectFlatTree(tree, parentUuid = null) {
      const flatTree = [];
      let order = 0;
      tree.forEach((item) => {
        item.order = order;
        order += 1;
        flatTree.push(item);
        item.parent_uuid = parentUuid;

        if (item.children_recursive) {
          flatTree.push(...this.collectFlatTree(item.children_recursive, item.uuid));
        }
      });
      return flatTree;
    }
  },
};
</script>

<style scoped></style>
